import React from 'react';
import { AdminCrudShell } from '@/components/admin/AdminCrudShell';
import { Badge } from '@/components/ui/badge';
import { formatMoney } from '@/lib/api';

const SCOPE_OPTS = [
  { value: 'platform', label: 'Plataforma' },
  { value: 'club', label: 'Club' },
];
const PERIOD_OPTS = [
  { value: 'daily', label: 'Diario (prueba)' },
  { value: 'monthly', label: 'Mensual' },
  { value: 'yearly', label: 'Anual' },
  { value: 'one_time', label: 'Pago único' },
];
const STATUS_OPTS = [
  { value: 'active', label: 'Activo' },
  { value: 'inactive', label: 'Inactivo' },
  { value: 'archived', label: 'Archivado' },
];

export default function AdminPlans() {
  return (
    <AdminCrudShell
      title="Planes de suscripción"
      subtitle="Gestiona los planes premium ofrecidos en la plataforma."
      entity="plans"
      testIdPrefix="admin-plans"
      
      addLabel="Nuevo plan"
      searchPlaceholder="Buscar por nombre…"
      initialForm={{ name: '', slug: '', description: '', price_cents: 0, currency: 'EUR', billing_period: 'monthly', access_scope: 'platform', club_id: '', status: 'active', sort_order: 0 }}
      columns={[
        { key: 'name', label: 'Nombre' },
        { key: 'access_scope', label: 'Scope', render: (r) => <Badge variant="secondary" className="uppercase tracking-wider text-[10px]">{r.access_scope}</Badge> },
        { key: 'billing_period', label: 'Periodo' },
        { key: 'price_cents', label: 'Precio', render: (r) => formatMoney(r.price_cents, r.currency) },
        { key: 'status', label: 'Estado', render: (r) => <Badge className={`text-[10px] uppercase ${r.status === 'active' ? 'bg-[var(--ns-gold)]/20 text-[var(--ns-gold-700)]' : 'bg-[var(--ns-bg-2)] text-[var(--ns-text-muted)]'}`}>{r.status}</Badge> },
      ]}
      formFields={[
        { name: 'name', label: 'Nombre', required: true, placeholder: 'Premium Plataforma' },
        { name: 'slug', label: 'Slug', hint: 'Si lo dejas vacío se genera automáticamente' },
        { name: 'description', label: 'Descripción', type: 'textarea', placeholder: 'Acceso ilimitado a…' },
        { name: 'price_cents', label: 'Precio (céntimos)', type: 'number', required: true, hint: 'Importe en céntimos. 590 = 5,90 €' },
        { name: 'currency', label: 'Moneda', placeholder: 'EUR', lowercase: false },
        { name: 'billing_period', label: 'Periodo', type: 'select', options: PERIOD_OPTS, required: true },
        { name: 'access_scope', label: 'Scope de acceso', type: 'select', options: SCOPE_OPTS, required: true },
        { name: 'club_id', label: 'Club ID (solo si scope=club)', placeholder: 'UUID club', dependsOn: (v) => v.access_scope === 'club', lowercase: false },
        { name: 'sort_order', label: 'Orden', type: 'number' },
        { name: 'status', label: 'Estado', type: 'select', options: STATUS_OPTS, required: true },
      ]}
    />
  );
}
